
const ESignature = () => {
  return (
    <div style={{paddingLeft: 300}}>
      <img src="/images/comingSoon/Deal List(sign).jpg" alt="" />
    </div>
  );
};
export default ESignature;
